import type uPlot from 'uplot';

/**
 * uPlot axis `size` function that grows the gutter to fit the widest tick
 * label (uPlot's fixed default of 50px clips five-digit euro amounts like
 * "20.000 €" — the labels render truncated at the canvas edge otherwise).
 * Canonical pattern from the uPlot docs: measure on cycle 1, reuse after.
 */
export function measuredAxisSize(
  u: uPlot,
  values: string[] | null | undefined,
  axisIdx: number,
  cycleNum: number,
): number {
  const axis = u.axes[axisIdx] as unknown as {
    _size: number;
    gap: number;
    ticks: { size: number };
    font: string[];
  };
  if (cycleNum > 1) return axis._size;

  let size = axis.ticks.size + axis.gap;
  const longest = (values ?? []).reduce((a, v) => (v.length > a.length ? v : a), '');
  if (longest !== '') {
    u.ctx.font = axis.font[0]!;
    size += u.ctx.measureText(longest).width / devicePixelRatio;
  }
  return Math.ceil(size);
}
